<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import KeywordPill from "@/components/approval-center/partials/ui/KeywordPill.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";

const {
  selectedApproval,
} = useApprovalFlow();

const emit = defineEmits(["close"]);
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <ModalHeader>
          <ModalHeading>All Keywords</ModalHeading>
          <ModalSubText>
            Boost your online visibility with targeted SEO keywords. Our team will optimize your content to attract more traffic. Let us help you rank higher in search results!
          </ModalSubText>
        </ModalHeader>

        <div class="tw-flex tw-flex-wrap tw-gap-2">
          <KeywordPill
            v-for="keyword in selectedApproval.approvable.keywords"
            :key="keyword.id"
          >
            {{ keyword.keyword }}
          </KeywordPill>
        </div>

        <div class="tw-flex tw-justify-center">
          <DefaultButton
            variant="primary-inverted"
            @click="emit('close')"
          >
            Close
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
